import { Paperclip } from 'lucide-react'
import React, { useRef } from 'react'
import { cn } from '@/helpers/utils'

const MultipleFileInput = ({
  label = 'Upload files',
  helpText,
  tabIndex,
  className,
  disabled,
  ...props
}) => {
  const fileInputRef = useRef()

  return (
    <>
      <button
        type='button'
        tabIndex={tabIndex}
        className={cn(
          "inline-flex items-center justify-center whitespace-nowrap rounded-sm text-sm font-medium transition-all",
          "border border-input bg-background shadow-xs hover:bg-accent hover:text-accent-foreground",
          "h-9 px-3 py-2",
          "w-fit",
          disabled && "opacity-50 pointer-events-none cursor-not-allowed",
          className
        )}
        onClick={() => fileInputRef.current.click()}
        disabled={disabled}
      >
        <Paperclip className='h-4 w-4 inline-block mr-2' />
        {label}
      </button>

      {helpText && (
        <small className='mt-1'>{helpText}</small>
      )}

      <input
        ref={fileInputRef}
        id={props.id || 'upload-button'}
        type='file'
        multiple
        className='hidden'
        disabled={disabled}
        {...props}
      />
    </>
  )
}

export default MultipleFileInput
